import type { MouseEvent } from 'react';

export const menuPanelBox = 'ui-min-w-52 ui-rounded-surface-card ui-bg-fill';

export function stopCardClick(e: MouseEvent) {
  e.stopPropagation();
}
